import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }: Theme) =>
  createStyles({
    table: {
      borderCollapse: 'separate',
      borderSpacing: '0 0.8rem',
      marginBottom: spacing(4),
      minWidth: 'max-content',
      padding: '1rem',

      '& > thead > tr': {},

      '& > thead > tr > th': {
        border: 'none',
        padding: '0 1rem 1rem 0',
        position: 'sticky',
        top: -1,
        background: 'white',

        '&:first-child > p': {
          marginLeft: '2rem',
        },

        '&:last-child > p': {
          padding: '0 1rem 1rem 0',
        },

        '& > p': {
          fontSize: '1.2rem',
        },
      },
    },
    notFoundDiagnoses: {
      fontWeight: 600,
      margin: `${spacing(2)} ${spacing(5)}`,
    },
    button: {
      width: 'auto',
      minWidth: 'max-content',
      gap: '0.8rem',
      margin: 0,
    },
  }),
)
